const SalesInvoiceReportFooter = ({ footerData }) => {
  return (
    <div className="__footer">
      <table width="100%">
        <tbody>
          <tr>
            <td align='center' colSpan={3}>
              Note: You will be invoiced with sales tax if you have not provided a valid resale Certificate
            </td>
          </tr>
          <tr>
            <td style={{ height: 0 }} width="33.33%" className='__footer_col_1'>
              <MyCard heading="Return Policy">
                <p>
                  1) No return of goods after 45 days of shipment.<br />
                  2) Damage goods must be returned within 10 days of shipment.<br />
                  3) No returns would be accepted without RA.<br />
                  4) All Return must include a copy of this packing list.<br />
                  5) Returns without an advance shipping notice (including tracking#) and an approved RA# will not be processed.
                </p>
              </MyCard>
            </td>
            <td style={{ height: 0 }} width="33.33%" className='__footer_col_2'/>
            <td style={{ height: 0 }} width="33.33%" className='__footer_col_3'>
              <MyCard heading="Return Address">
                <p>
                  Bergen Shippers DLPD Canada LTD c/o Bergen Logistics<br />
                  3925 Steeles Ave East UNIT # 3 Brampton, ON L6T 5W5<br />
                  Contact Person : Mary Williams<br />
                  Tel: 905 792 8585 Ext.25
                </p>
              </MyCard>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default SalesInvoiceReportFooter;

const MyCard = ({ heading, children }) => (
  <div className="__card">
    {heading && <h4
      style={{
        display: "flex",
        justifyContent: "center",
        textDecoration: "underline",
      }}
    >{heading}</h4>}
    {children}
  </div>
)